import BusinessAttributes from "./BusinessAttributes";
import { useGetBusinessAttributesQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import Loader from "uicomponents/Loader";
import Error from "uicomponents/Error";

interface IBusinessAttributesProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
}

const BusinessAttributesModel = ({ ...props }: IBusinessAttributesProps) => {
  const { data, error, loading } = useGetBusinessAttributesQuery({
    variables: { uuid: getProspectUuid() },
    fetchPolicy: "no-cache",
  });
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }
  return (
    <BusinessAttributes
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
      data={data?.prospect}
    />
  );
};

export default BusinessAttributesModel;
